







import { Component, Vue } from "vue-property-decorator";

@Component
export default class LanguagePicker extends Vue {
  private selected: string = "";

  async mounted() {
    this.selected = window.localStorage.getItem("dzs.cms.language") || "hr";
  }

  select(language: string) {
    window.localStorage.setItem("dzs.cms.language", language);
    window.location.reload();
  }
}
